import styled from 'styled-components';
import { Responsive, WidthProvider } from 'react-grid-layout';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const BaseGridLayout = WidthProvider(Responsive);

export const StyledGridLayout = styled(BaseGridLayout)`
  .react-grid-item {
    overflow: visible !important;
    position: absolute;
    z-index: 0;

    transition: all 200ms ease;

    &:hover,
    &:focus-within,
    &:focus-visible {
      z-index: 3;
    }
  }
`;

export const DescriptionQuillContainer = styled(ReactQuill)`
  flex: 1;
  display: flex !important;
  flex-direction: column;
  width: 100% !important;
  height: 100% !important;
  min-height: 0 !important;

  .ql-toolbar {
    border: 1px solid #ced4da !important;
    border-bottom: none !important;
    border-radius: 6px 6px 0 0 !important;
    background: #fff;
    flex-shrink: 0;
  }

  > .ql-container {
    flex: 1;
    border: 1px solid #ced4da !important;
    border-top: none !important;
    border-radius: 0 0 6px 6px !important;
    background: #fff;
    height: auto !important;
    min-height: 0 !important;
    display: flex;
    flex-direction: column;
  }

  > .ql-container > .ql-editor {
    min-height: 0 !important;
    padding: 10px 14px !important;
    overflow-y: auto;
    box-sizing: border-box;
    flex: 1;
  }
`;

export const DescriptionUpdateProtocolQuillContainer = styled(ReactQuill)`
  .ql-editor {
    z-index: 9999;
    transition: all 0.3s ease;
    font-weight: normal;

    strong,
    b {
      font-weight: bold;
    }
  }
`;
